import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  field: { marginBottom: theme.spacing(2) },
  providerOption: {
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    alignItems: "flex-start",
    width: "100%",
  },
  providerOptionActive: { borderColor: theme.palette.primary.main, background: "rgba(33,150,243,0.04)" },
  providerDesc: { fontSize: "0.78rem", color: theme.palette.text.secondary },
  note: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
    fontStyle: "italic",
  },
}));

// Modal de creación de flujo. El provider se elige AQUÍ y es inmutable (0371 WF0):
// un flujo es Baileys O WABA, nunca mixto. Determina qué nodos valida el editor y
// qué conexiones se pueden asociar en flowcampaigns.
export default function NewFlowModal({ open, onClose, onConfirm }) {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [provider, setProvider] = useState("baileys");
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    if (saving) return;
    setName("");
    setProvider("baileys");
    onClose();
  };

  const handleConfirm = async () => {
    if (!name.trim()) return;
    try {
      setSaving(true);
      await onConfirm({ name: name.trim(), provider });
    } finally {
      setSaving(false);
    }
  };

  const providerCard = (value, title, desc) => (
    <FormControlLabel
      value={value}
      control={<Radio color="primary" size="small" />}
      className={`${classes.providerOption} ${provider === value ? classes.providerOptionActive : ""}`}
      label={
        <span>
          <Typography variant="body2" style={{ fontWeight: 600 }}>{title}</Typography>
          <span className={classes.providerDesc}>{desc}</span>
        </span>
      }
    />
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nuevo Flujo</DialogTitle>
      <DialogContent dividers>
        <TextField
          className={classes.field}
          autoFocus
          fullWidth
          size="small"
          variant="outlined"
          label="Nombre del flujo"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") handleConfirm(); }}
        />

        <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
          ¿Por qué canal correrá este flujo?
        </Typography>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup value={provider} onChange={(e) => setProvider(e.target.value)}>
            {providerCard(
              "baileys",
              "WhatsApp (no oficial · Baileys/Evolution)",
              "Texto, media y botones libres en cualquier momento. Es el flujo clásico."
            )}
            {providerCard(
              "waba",
              "WhatsApp Cloud API (Meta · WABA)",
              "Reglas de Meta: fuera de la ventana de 24 h solo plantillas HSM aprobadas, botones limitados. Ideal para iniciar conversaciones."
            )}
          </RadioGroup>
        </FormControl>

        <Typography className={classes.note}>
          El canal no se puede cambiar después de crear el flujo.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={saving || !name.trim()}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? "Creando..." : "Crear y editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
